import axios from 'axios';

import DOService from "@/services/do.service";

const MSG_START_BULKGI = "Mulai GI... ( Jangan refresh atau tutup Window ini )"
const MSG_DONE_BULKGI = "Selesai GI"

export default {
    name: 'TxBulkGI',
    data() {
      return {
          titleBulkGI: MSG_START_BULKGI,
          headerBgVariant: 'dark',
          headerTextVariant: 'light',
          processGI: null,
          errorGI: '',
          giResult: [
              {
                  status: "OK",
                  message: "DO: xxxxx OK"
              },
              {
                  status: "OK",
                  message: "DO: yyyyy OK"
              }
          ],
      }
    },
    methods: {
        doCallServerBulkGI(selectedDo) {
            /* eslint-disable no-console */

            this.giResult = []
            this.processGI = true
            this.titleBulkGI = MSG_START_BULKGI

            let vm = this
            DOService.bulkGI(selectedDo, function(error,doId) {

                //console.log(">> ******** {}: {}",doId, error.response )

                if (error.response.status === 401) {
                    vm.giResult.push( {
                        status: 401,
                        message: 'Unauthorized'
                    })
                    vm.$store.dispatch('auth/logout');
                    vm.$router.push('/login')
                    return
                }
                vm.giResult.push( {
                    status: error.response.status,
                    message: 'DO : ' + doId +
                        ' , Error: ' +
                        ((error.response && error.response.data) ?
                            error.response.data.error :
                            error.toString())
                })

            }).then(
                axios.spread((...responses) => {
                    for(let iii = 0; iii < responses.length; iii++) {
                        if (!responses[iii]) {
                            continue
                        }
                        vm.giResult.push({
                                status: 200,
                                message: 'DO : ' + selectedDo[iii]
                                    + ' ' + responses[iii].data.message
                            }
                        )
                    }
                }))

            /* eslint-enable no-console */

            let iId = null;
            let fCheck = function(){
                if (vm.giResult.length >= selectedDo.length ) {
                    clearInterval(iId);
                    vm.processGI = false
                    vm.titleBulkGI = MSG_DONE_BULKGI
                }
            };
            iId = setInterval(fCheck, 500);

        },
    },
}